module.exports = __webpack_public_path__ + "static/media/grillme_feature_graphic.8d89dd93.png";